"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var d3Sankey = require("d3-sankey");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var geometry_1 = require("../geometry");
/**
 * Reference: https://github.com/d3/d3-sankey#alignments
 * 0 - Justify
 * 1 - Left
 * 2 - Right
 * 3 - Center
 */
var Alignment;
(function (Alignment) {
    Alignment[Alignment["sankeyJustify"] = 0] = "sankeyJustify";
    Alignment[Alignment["sankeyLeft"] = 1] = "sankeyLeft";
    Alignment[Alignment["sankeyRight"] = 2] = "sankeyRight";
    Alignment[Alignment["sankeyCenter"] = 3] = "sankeyCenter";
})(Alignment = exports.Alignment || (exports.Alignment = {}));
var SankeyChart = /** @class */ (function (_super) {
    __extends(SankeyChart, _super);
    function SankeyChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SankeyChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_nodeWidth":
            case "_nodePadding":
                return utils_1.parseNumberWithAuto(value);
            case "_labelFunc":
                return utils_1.parseFunc(value);
            case "_nodeAlign":
                return {
                    "sankeyJustify": d3Sankey.sankeyJustify,
                    "sankeyLeft": d3Sankey.sankeyLeft,
                    "sankeyRight": d3Sankey.sankeyRight,
                    "sankeyCentre": d3Sankey.sankeyCenter,
                }[value];
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    SankeyChart.prototype.defaultOptions = function () {
        return {
            _nodeAlign: d3Sankey.sankeyJustify,
            _nodeWidth: 36,
            _nodePadding: 10,
            _labelFunc: function (d) { return d.index; },
        };
    };
    SankeyChart.prototype.init = function () {
        var _this = this;
        this._toolTip = __1.tooltip.create("linktip");
        this._rectGroups = this.appendGroupT(_1.Component).data([]).options({
            class: "group",
            _x: function (d) { return d.x0; },
            _y: function (d) { return d.y0; },
            _width: function (d) { return d.x1 - d.x0; },
            _height: function (d) { return d.y1 - d.y0; },
            _$mouseEnter: function (d) {
                d.sourceLinks.forEach(function (node) { return d3.select("#link" + node.index).classed("active", true); });
                d.targetLinks.forEach(function (node) { return d3.select("#link" + node.index).classed("active", true); });
            },
            _$mouseLeave: function (d) {
                d.sourceLinks.forEach(function (node) { return d3.select("#link" + node.index).classed("active", false); });
                d.targetLinks.forEach(function (node) { return d3.select("#link" + node.index).classed("active", false); });
            },
        });
        this._rects = this._rectGroups.appendT(element_1.Rect).options({
            _anchor: 2 /* Top */ | 16 /* Left */,
            _width: geometry_1.GeometryValue.fullSize,
            _height: geometry_1.GeometryValue.fullSize,
        });
        this._texts = this._rectGroups.appendT(element_1.Text).options({
            _anchor: 4 /* Middle */ | 32 /* Center */,
            _x: "50%",
            _y: "50%",
            _text: function (d) { return _this._labelFunc(d); },
        });
        this._links = this.appendGroupT(element_1.Path).data([]).options({
            class: "paths",
            id: function (d) { return "link" + d.index; },
            d: function (d) {
                var source = d.source;
                var target = d.target;
                var curvature = .6;
                var x0 = source.x1;
                var x1 = target.x0;
                var xi = d3.interpolateNumber(x0, x1);
                var x2 = xi(curvature);
                var x3 = xi(1 - curvature);
                var y0 = source.y0;
                var y1 = target.y0;
                return "M" + x0 + "," + y0 + "\n                        C" + x2 + "," + y0 + " " + x3 + "," + y1 + " " + x1 + "," + y1 + "\n                        L" + x1 + ", " + (y1 + target.y1 - target.y0) + "\n                        C" + x3 + ", " + (y1 + target.y1 - target.y0) + " " + x2 + "," + (y0 + source.y1 - source.y0) + " " + x0 + "," + (y0 + source.y1 - source.y0) + "\n                        L" + x0 + "," + y0;
            },
            _$mouseEnter: function (_, i, g) {
                d3.select(g[i]).classed("active", true);
            },
            _$mouseLeave: function (_, i, g) {
                d3.select(g[i]).classed("active", false);
            },
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._links.dom)
                    .renderHTML(function (d) {
                    return "source: " + d.source.index + ",\n                                target: " + d.target.index + ",\n                                value: " + d.value;
                });
            },
        });
    };
    SankeyChart.prototype.prepare = function () {
        this._labelFunc = this.getOption("_labelFunc");
        var svgHeight = this._getGeometry("_height", false);
        var svgWidth = this._getGeometry("_width", true);
        var sankey = d3Sankey.sankey()
            .nodeWidth(this.getOption("_nodeWidth"))
            .nodePadding(this.getOption("_nodePadding"))
            .size([svgWidth, svgHeight])
            .nodeAlign(this.getOption("_nodeAlign"));
        var graph = sankey(this.datum);
        this._rectGroups.data(graph.nodes);
        this._links.data(graph.links);
        this.setupProxy({
            rect: "_rects",
            link: "_links",
            label: "_texts",
        });
    };
    return SankeyChart;
}(_1.Component));
exports.SankeyChart = SankeyChart;
//# sourceMappingURL=sankey-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/sankey-chart.js
// module id = 1166
// module chunks = 0 1